import zhCn from './zhCn'
import zhTw from './zhTw'
import en from './en'

export default {zhCn, zhTw, en}



